import { sourceHasValidMedia } from "~components/shared/media/";
import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentMagazineGrid";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const itemsWithMagCover = items?.filter((item) =>
        sourceHasValidMedia(item, MEDIA_PRIORITY)
    );

    return checkItemArrayIntegrity(itemsWithMagCover, ["id"]);
}
